import {
  AllEntitiesResolved,
  EntityNotResolved,
  EntityResolved,
} from '@api/api/entities';
import { formatTicker } from '@api/mappers/formatTicker';
import { isJapaneseLocale, isKoreanLocale } from '@helpers/utils/locale/locale';

export const isNewEntity = ({
  tag,
  entitiesList,
}: {
  tag: string;
  entitiesList: EntityResolved[];
}) => !entitiesList.some(e => e.tag === tag);

export const splitAllResolvedEntities = (
  entitiesResolved: AllEntitiesResolved[],
  entitiesList: EntityResolved[]
) => {
  const unMappedEntitiesList = entitiesResolved
    .filter(r => !r.tag)
    .map(r => ({ input: r.input }));

  const mappedEntities = entitiesResolved.filter(
    r => r.tag
  ) as EntityResolved[];

  const tableDuplicates = mappedEntities
    .filter(e => entitiesList.some(entity => entity.tag === e.tag))
    .map(e => formatTicker(e));

  return {
    mappedEntities,
    unMappedEntitiesList,
    tableDuplicates,
  };
};

export const mergeDuplicateTickers = (
  resultDuplicated: string[],
  tableDuplicates: string[]
) => {
  return Array.from(new Set([...resultDuplicated, ...tableDuplicates]));
};

export const mergeUnMappedEntitiesLists = (
  unMappedEntitiesList: EntityNotResolved[],
  searchUnMappedEntities: EntityNotResolved[]
) => {
  return [
    ...unMappedEntitiesList,
    ...searchUnMappedEntities.filter(
      d => !unMappedEntitiesList.some(e => e.input === d.input)
    ),
  ];
};

export const shouldOnBoardingBeActive = ({
  isNewUser,
  isCompleted,
}: {
  isNewUser: boolean;
  isCompleted: boolean;
}) => {
  return !isJapaneseLocale() && !isKoreanLocale() && isNewUser && !isCompleted;
};
